import { createRouter, createWebHistory } from 'vue-router';
import { token } from './lib/api';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/events' },
    { path: '/login', component: () => import('./views/Login.vue'), meta: { public: true } },
    { path: '/events', component: () => import('./views/Events.vue') },
    { path: '/events/:id/prizes', component: () => import('./views/Prizes.vue') },
    { path: '/devices', component: () => import('./views/Devices.vue') },
    { path: '/spins', component: () => import('./views/Spins.vue') },
  ],
});

router.beforeEach((to) => {
  if (!to.meta.public && !token()) return '/login';
  if (to.path === '/login' && token()) return '/events';
});
